import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import {SelectElementProps} from './SelectElement.type';
import SVGIcons from '../../components/SVGIcon';
import {MenuProps} from '@mui/material';
import {
  MENU_ITEM_STYLE,
  MENU_STYLE,
  SELECTED_ELEMENT_STYLE,
} from './SelectElement.constants';

import style from './SelectElement.style.module.scss';

//render the select element with dropdown options
export function SelectElement({
  onChange,
  className,
  handleClose,
  SelectRef,
  menuItemProps,
  selectedElementClassname,
  isClear,
  ...props
}: SelectElementProps) {
  // State to manage the open/close state of the menu
  const [open, setOpen] = React.useState(false);

  const handleOpenMenu = () => setOpen(true);
  const handleCloseMenu = () => setOpen(false);
  const handleMenuItemClick = () => handleCloseMenu();

  // Function to get the JSX block for displaying the icon elements
  const getIconBlock = () => (
    <div className={style.iconContainer}>
      {isClear && props.value && (
        <span className={style.arrow} onClick={handleClose}>
          <SVGIcons type={'close-svg'} />{' '}
        </span>
      )}
      <span className={style.arrow} onClick={handleOpenMenu}>
        <SVGIcons type={'downarrow-svg'} />{' '}
      </span>
    </div>
  );

  // Customize the menu's appearance and behavior
  const menuProps: Partial<MenuProps> = {
    PaperProps: {
      style: props.customstyle ? props.customstyle : MENU_STYLE,
      className: style.menuContainer,
    },
    ...(menuItemProps && {...menuItemProps}),
    open,
    onClose: handleCloseMenu,
  };

  const getLabel = () => {
    const {options, value, placeholder} = props;
    const foundObject = options.find((obj) => obj.value === value);
    const label = foundObject ? foundObject.label : value;
    return (
      <span
        className={`${label ? style.valueLabel : style.placeHolder} ${selectedElementClassname  
          }`}>
        {label || placeholder}
      </span>
    );
  };

  const customStyles = props.customSelectStyle
    ? props.customSelectStyle
    : {borderRadius: '0px'};

  // Render the Select component with customized options

  return (
    <Select
      ref={SelectRef}
      className={`${style.container} ${className}`}
      sx={customStyles}
      onChange={onChange}
      IconComponent={() => getIconBlock()}
      MenuProps={menuProps}
      SelectDisplayProps={SELECTED_ELEMENT_STYLE}
      open={open}
      onOpen={handleOpenMenu}
      displayEmpty={true}
      value={props.value}
      data-testid={props.testid}
      renderValue={() => getLabel()}
      {...props}>
      {props.options.length == 0 ? (
        <MenuItem sx={MENU_ITEM_STYLE}>No options available</MenuItem>
      ) : (
        props.options?.map((item) => (
          <MenuItem
            value={item.value}
            key={item.value}
            onClick={handleMenuItemClick}
            divider={true}
            sx={MENU_ITEM_STYLE}>
            {item.label}
          </MenuItem>
        ))
      )}
    </Select>
  );
}
